import { initializeApp } from "firebase/app";
import {
  getFirestore,
  getDocs,
  collection,
  setDoc,
  doc,
  query,
  where,
  onSnapshot,
} from "firebase/firestore";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendEmailVerification,
  sendPasswordResetEmail,
} from "firebase/auth";
import { generateCustomId } from "utils/utils";
import { setData } from "store/slices/firebaseSlice";

// TODO: Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/learn-more#config-object
const firebaseConfig = {
  apiKey: "AIzaSyCZ7msEslvhndvwcWbQcuM3glmflaEyLAo",
  authDomain: "milkanalyzer-763e5.firebaseapp.com",
  projectId: "milkanalyzer-763e5",
  storageBucket: "milkanalyzer-763e5.firebasestorage.app",
  messagingSenderId: "159930513609",
  appId: "1:159930513609:web:cf967f41c43680aae7b518",
  measurementId: "G-8H3FJCR8NE",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export const db = getFirestore(app);

export const createUser = async (email, password) => {
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  const user = userCredential.user;

  // Send email verification
  await sendEmailVerification(user);

  const resultsRef = collection(db, "Results");
  const clientId = generateCustomId();
  await setDoc(doc(resultsRef, clientId), {
    userId: user.uid,
  });
  return { user, clientId };
};

export const logIn = async (email, password) => {
  const data = await signInWithEmailAndPassword(auth, email, password);

  // Check if email is verified
  if (!data.user.emailVerified) {
    throw new Error(
      "Please verify your email before signing in. Check your inbox for the verification link."
    );
  }

  return data;
};

export const resetPassword = async (email) => {
  await sendPasswordResetEmail(auth, email);
};

export const resendVerificationEmail = async (email, password) => {
  // Sign in the user first to get their auth object
  const userCredential = await signInWithEmailAndPassword(auth, email, password);
  const user = userCredential.user;

  // Check if already verified
  if (user.emailVerified) {
    throw new Error("Email is already verified.");
  }

  // Send verification email
  await sendEmailVerification(user);

  // Sign out the user since they're not verified
  await signOut(auth);
};

export const getClientDataByUid = async (uid) => {
  const data = [];
  const q = query(collection(db, "Results"), where("userId", "==", uid));
  const querySnap = await getDocs(q);
  const client = querySnap.docs[0];
  return { clientId: client.id, clientData: client.data() };
};

export const isLoggedIn = () =>
  new Promise((resolve, reject) => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        return resolve(user);
      }
      return reject("error");
    });
  });

export const firebaseLogout = async () => {
  try {
    signOut(auth);
  } catch (error) {
    console.error(error);
  }
};
